import React, { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import Tables from "../../../components/Tables";
import { getDateChangeTime } from "../../../../helper/helper";
import { TYPE_GET_DATE } from "../../../../helper/const";
import FilterTimeDate from "../../../Natcom/components/FilterTimeDate";
import { formatDataBitelAirtime } from "../../../../helper/helper";
import styled from "styled-components";

export default function Details({ handleGetData, tabActive }) {
  const [date, setDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { result = {} } =
    useSelector((state) => state.reducerAirtimeBitel?.data) || {};
  const { data: airtime_bitel } = result;

  useEffect(() => {
    if (tabActive !== "2") return;
    handleGetData(date, date);
  }, [date, tabActive]);

  const columns = useMemo(() => {
    if (airtime_bitel) {
      const data = formatDataBitelAirtime(airtime_bitel[date]);   
      return data;
    }
  }, [airtime_bitel, date]);
  return (
    <Container>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTimeDate date={date} setDate={setDate} />
      </div>
      <Tables
        columns={columns}
        title="Overview statistic table"
        isHiddenPagination={false}
      />
    </Container>
  );
}

const Container = styled.div`
  .panel-sortable {
    tr:last-child {
      td {
        font-weight: 600;
      }
    }
  }
`;
